
const text = {
    id: {
        login_heading: 'MASUK',
        login_welcome: 'Selamat Datang',
        login_paragraph: 'Silahkan masuk dengan akun Anda',
        login_register: 'Buat Akun',
        login_forgot: 'Lupa Kata Sandi',

        forgot_heading: 'LUPA KATA SANDI ANDA',
        forgot_paragraph: 'Silakan masukkan alamat email Anda dan kami akan mengirimkan tautan untuk mengganti kata sandi Anda.',

        forgot_success_heading: 'Periksa Email Anda!',
        forgot_success_paragraph: 'Kami baru saja mengirimi Anda email petunjuk untuk mereset kata sandi Anda',

        register_heading: 'BUAT AKUN',
        register_step: 'LANGKAH 1 DARI 2',
        register_have_account: 'Sudah mempunyai akun',
        register_login: 'Masuk disini',
        register2_heading: 'MEMBUAT INFORMASI PERUSAHAAN',
        register2_step: 'LANGKAH 2 DARI 2',
        register2_tnc: 'Saya menerima syarat dan ketentuan & kebijakan privasi',

        success_heading: 'Terima Kasih',
        success_company_paragraph: 'Silakan periksa email Anda untuk aktivasi akun.',
        success_company_detail: 'Kami telah mengirimi Anda email dengan tautan untuk aktivasi akun',

        landing_paragraph: 'Terima kasih telah bergabung bersama kami!',
        reservation_welcome: 'Selamat Datang',
        reservation_timer: 'Update Waktu Tersisa Pengiriman',
        reservation_time_up: 'Waktu pengiriman sudah habis. Data pengiriman sudah di atur ulang',
        reservation_paragraph1: 'Siap menambah pengiriman pertama Anda?',
        reservation_paragraph2: 'Silakan masukkan di bawah ini, atau Anda dapat melewati sekarang.',
        reservation_heading: 'Buat Pengiriman Baru',
        reservation_step: 'Langkah',
        reservation_step1_text: 'Pilih Gudang Penyimpanan & Waktu Pengiriman',
        reservation_step1_alert: 'Slot Waktu Tersedia! Mohon untuk tepat waktu saat pengiriman barang.',
        reservation_step2_text: 'Pilih Produk Yang Akan Dikirim',
        reservation_step3_text: 'Cetak Label',
        reservation_product: 'Daftar Produk Anda',

        product_alert: 'Masukkan ukuran dengan tepat',

        note_heading: 'Surat Jalan Pengiriman',
        note_text: 'cetak surat jalan ini untuk bukti penyerahan produk saat pengiriman. Tempelkan Kode Produk (IKU) ke setiap produk yang terdaftarkan dengan tepat.',

        label_email: 'Email',
        label_password: 'Kata Sandi',
        label_password_confirm: 'Konfirmasi Kata Sandi',
        label_name: 'Nama',
        label_first_name: 'Nama Depan',
        label_last_name: 'Nama Belakang',
        label_phone: 'Nomor Telepon',
        label_company: 'Nama Perusahaan',
        label_company_only: 'Perusahaan',
        label_iku: 'Daftar Label IKU',
        label_nota: 'Nomor Nota',
        label_nota_delivery: 'Surat Jalan Pengiriman',
        label_address: 'Alamat',
        label_subdistrict: 'Kelurahan',
        label_district: 'Kecamatan',
        label_city: 'Kota',
        label_state: 'Provinsi',
        label_zipcode: 'Kode Pos',
        label_name_contact: 'Nama Kontak PIC',
        label_handphone: 'Nomor Handphone PIC',
        label_type_contact: 'Jabatan PIC',
        label_dashboard: 'Dasbor',
        label_reservation: 'Pengiriman',
        label_reservation_code: 'Kode Pengiriman',
        label_reservation_date: 'Tgl Pengiriman',
        label_warehouses: 'Tempat Penyimpanan',
        label_warehouses_date: 'Tgl Penyimpanan',
        label_admins: 'Admin',
        label_users: 'Pengguna',
        label_orders: 'Fulfillment',
        label_tenants: 'Penyewa',
        label_assets: 'Inventaris',
        label_roles: 'Peran',
        label_logout: 'Keluar',
        label_action: 'Aksi',
        label_products: 'Produk',
        label_status: 'Status',
        label_history: 'Riwayat',

        label_minute: 'Menit',
        label_warehouse_place: 'Alamat Tempat Penyimpanan',
        label_warehouse_address: 'Alamat Tempat Penyimpanan',
        label_warehouse_destination_address: 'Alamat Tempat Pengiriman',
        label_warehouse: 'Pilih Gudang Penyimpanan',
        label_time: 'Waktu Pengiriman',

        label_delivery_HQ: 'Pengiriman akan tiba di gudang pusat',
        label_delivery_cost:'Pengiriman akan dikenakan biaya',
        label_delivery_must_received:'Barang harus diterima di gudang penyimpanan',

        label_sku: 'SKU Produk',
        label_product: 'Nama Produk',
        label_quantity: 'Jumlah',
        label_slot: 'Slot',
        label_delete: 'Hapus',
        label_available: 'Penyimpanan tersedia',
        label_unavailable: 'Penyimpanan tidak tersedia',

        label_add_product: 'Tambah Produk',
        label_reservation_summary: 'Ringkasan Pengiriman',
        label_tooltip: 'Ukuran maksimal 300x300 pixel jenis gambar (.jpg)',
        label_upload: 'Foto Produk',
        label_upload_company: 'Foto Perusahaan',
        label_storage: 'Area',
        label_category: 'Kategori Produk',
        label_weight: 'Berat',
        label_width: 'Lebar',
        label_height: 'Tinggi',
        label_length: 'Panjang',
        label_locker: 'Ukuran Loker',
        label_no_locker: 'Tidak Tersedia',
        label_packaging: 'Kemasan',
        label_other: 'Lainnya',
        label_shelf: 'Umur Simpan',
        label_days: 'Hari',
        label_product_price: 'Harga Produk',
        label_product_desc: 'Deskripsi Produk',
        label_browse: 'Cari',
        label_price: 'Harga',
        label_size: 'Ukuran',

        label_order_code: 'Kode Fulfillment',
        label_order_date: 'Tgl Fulfillment',
        label_receiver: 'Penerima',
        label_receiver_contact: 'Kontak Penerima',
        label_receiver_phone: 'Telepon Penerima',
        label_platform: 'Platform',
        label_logistic: 'Kurir',

        label_no: 'Data kosong',
        label_not_found: 'Data tidak ditemukan',

        button_login: 'MASUK',
        button_submit: 'Kirim',
        button_next: 'LANJUTKAN',
        button_back: 'Kembali',
        button_register: 'DAFTAR',
        button_add_list: 'Tambah Daftar',
        button_add: 'Tambah',
        button_done: 'SELESAI',
        button_skip: 'Lewati',
        button_edit: 'Ubah',
        button_save: 'Simpan',
        button_cancel: 'Batal',
        button_delete: 'Hapus',
        button_print: 'Cetak Surat Jalan',
        button_print_delivery_note: 'Cetak Surat Jalan',

        //start labeling reservations
        label_contact:'Kontak',
        label_sortBy:'Cari berdasarkan',
        label_stock_unavailable:'Stok produk di gudang kosong',
        

        //inventory
        label_expired:'Umur Simpan',

    },
    en: {
        login_heading: 'LOGIN',
        login_welcome: 'Welcome',
        login_paragraph: 'Please login your account',
        login_register: 'Register',
        login_forgot: 'Forgot Password',

        forgot_heading: 'FORGOT YOUR PASSWORD',
        forgot_paragraph: 'Please fill your email and we will send the email to reset your password.',

        forgot_success_heading: 'Please Check Your Email!',
        forgot_success_paragraph: 'We just sent you an email on how to reset your password.',

        register_heading: 'REGISTER',
        register_step: 'STEP 1 OF 2',
        register_have_account: 'Have account?',
        register_login: 'Login here',
        register2_heading: 'CREATE COMPANY INFORMATION',
        register2_step: 'STEP 2 OF 2',
        register2_tnc: 'I accept the terms, condition and privacy policy',

        success_heading: 'Thank You',
        success_company_paragraph: 'Please check your email to activate yout account',
        success_company_detail: 'We already send you email to activate your account',

        landing_paragraph: 'Thank you for joining us!',
        reservation_welcome: 'Welcome',
        reservation_timer: 'Time left remaining for Reservation',
        reservation_time_up: 'Time Up for Reservation. Data has been reset',
        reservation_paragraph1: 'Ready to add your first reservation?',
        reservation_paragraph2: 'Please continue or you might to skip.',
        reservation_heading: 'Create New Reservation',
        reservation_step: 'Step',
        reservation_step1_text: 'Choose Warehouse and Shipping Time',
        reservation_step1_alert: 'Slot Time Available! Please be on time for the shipping time.',
        reservation_step2_text: 'Choose your products to send',
        reservation_step3_text: 'Print Label',
        reservation_product: 'Your Product List',

        product_alert: 'Input the correct size',

        note_heading: 'Reservation Notes',
        note_text: 'print this as a proof when shipping. Paste the Product Code (IKU) into each product that is registered correctly.',

        label_email: 'Email',
        label_password: 'Password',
        label_password_confirm: 'Password Confirmation',
        label_name: 'Name',
        label_first_name: 'First Name',
        label_last_name: 'Last Name',
        label_phone: 'Phone',
        label_company: 'Company Name',
        label_company_only: 'Company',
        label_iku: 'Daftar Label IKU',
        label_nota: 'Number Nota',
        label_nota_delivery: 'Delivery Note',
        label_address: 'Address',
        label_subdistrict: 'Subsdistrict',
        label_district: 'District',
        label_city: 'City',
        label_state: 'State',
        label_zipcode: 'Zip Code',
        label_name_contact: 'PIC Name',
        label_handphone: 'PIC Phone Cell',
        label_type_contact: 'PIC Title',
        label_dashboard: 'Dashboard',
        label_reservation: 'Reservations',
        label_reservation_code: 'Reservation Code',
        label_reservation_date: 'Reservation Date',
        label_warehouses: 'Warehouses',
        label_warehouses_date: 'Store Date',
        label_admins: 'Admins',
        label_users: 'Users',
        label_orders: 'Fulfillment',
        label_tenants: 'Tenants',
        label_assets: 'Assets',
        label_roles: 'Roles',
        label_logout: 'Sign out',
        label_action: 'Action',
        label_products: 'Products',
        label_status: 'Status',
        label_history: 'Riwayat',

        label_minute: 'Minutes',
        label_warehouse_place: 'Warehouse',
        label_warehouse_address: 'Warehouse Addresses',
        label_warehouse_destination_address: 'Warehouse Destination Addresses',
        label_warehouse: 'Choose Warehouse',
        label_time: 'Time Shipping',

        label_delivery_HQ: 'Pengiriman akan tiba di gudang pusat',
        label_delivery_cost:'Pengiriman akan dikenakan biaya',
        label_delivery_must_received:'Barang harus diterima di gudang penyimpanan',

        label_sku: 'Product SKU',
        label_product: 'Product Name',
        label_quantity: 'Quantity',
        label_slot: 'Slot',
        label_delete: 'delete',
        label_available: 'Slot available',
        label_unavailable: 'Slot unavailable',

        label_add_product: 'Add Product',
        label_reservation_summary: 'Reservation Summary',
        label_tooltip: 'Max image size : 1 MB',
        label_upload: 'Image Product',
        label_upload_company: 'Image Company',
        label_storage: 'Zone',
        label_category: 'Product Category',
        label_weight: 'Weight',
        label_width: 'Width',
        label_height: 'Height',
        label_length: 'Length',
        label_locker: 'Locker Size',
        label_no_locker: 'Not Found',
        label_packaging: 'Packaging',
        label_other: 'Other',
        label_shelf: 'Shelf Life',
        label_days: 'Days',
        label_product_price: 'Product Price',
        label_product_desc: 'Product Description',
        label_browse: 'Browse',
        label_price: 'Price',
        label_size: 'Size',

        label_order_code: 'Order Code',
        label_order_date: 'Order Date',
        label_receiver: 'Receiver',
        label_receiver_contact: 'Receiver Contact',
        label_receiver_phone: 'Receiver Phone',
        label_platform: 'Platform',
        label_logistic: 'Logistic',

        label_no: 'Data empty',
        label_not_found: 'Data not found',

        button_login: 'LOGIN',
        button_submit: 'Submit',
        button_next: 'NEXT',
        button_back: 'Back',
        button_register: 'REGISTER',
        button_add_list: 'Add Row',
        button_add: 'Add',
        button_done: 'DONE',
        button_skip: 'Skip',
        button_edit: 'Edit',
        button_save: 'Save',
        button_cancel: 'Cancel',
        button_delete: 'Delete',
        button_print: 'Print Label',
        button_print_delivery_note: 'Print Delivery Note',

        //start labeling reservations
        label_contact:'Contact',
        label_sortBy:'Sort by',
        label_stock_unavailable:'Stock product unavailable',

        label_expired:'Save age',
    }
};

export default text;
